export const USER_TYPE = {
    'SUB_ADMIN': 'sub-admin',
    'OWNER': 'owner',
    'USER': 'user',
};